import T from './language'
export const double = (str) => {
  return str.toString().padStart(2, '0')
}

export const formatDate = (time) => {
  const date = new Date(time)

  return `${date.getFullYear()}/${double(date.getMonth() + 1)}/${double(
    date.getDate()
  )} ${double(date.getHours())}:${double(date.getMinutes())}:${double(
    date.getSeconds()
  )}`
}

// 判断是否是微信浏览器
export const isWX = () => {
  return (
    Number(navigator.userAgent.toLowerCase().indexOf('micromessenger')) !== -1
  )
}

// 从url获取参数
export const getUrlParms = (location, name) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  const str = '?' + location.split('?')[1]
  const r = str.substr(1).match(reg)
  if (r !== null) return unescape(r[2])
  return null
}

export const getSoltStateList = () => {
  return [
    {
      name: T('无电池'),
      color: '#FFFFFF',
    },
    {
      name: T('正常电池'),
      color: '#1DBFE6',
    },
    {
      name: T('低电量电池'),
      color: '#96D7FF',
    },
    {
      name: T('充电异常'),
      color: '#FEC93B',
    },
    {
      name: T('通讯异常'),
      color: '#999999',
    },
    {
      name: T('无法弹出'),
      color: '#F5222D',
    },
    {
      name: T('机芯故障'),
      color: '#CCCCCC',
    },
    {
      name: T('黑名单电池'),
      color: '#252525',
    },
    {
      name: T('异常投放'),
      color: '#C79FFF',
    },
    {
      name: T('低分电池'),
      color: '#AD4E00',
    },
    {
      name: T('充电电量异常'),
      color: '#FFA23F',
    },
  ]
}
